/**
 * Generic color-coded status badge.
 * @param {{
 *   label: string,
 *   variant?: 'success' | 'warning' | 'error' | 'info' | 'neutral' | 'orange',
 *   className?: string,
 * }} props
 */

const VARIANT_CLASSES = {
  success: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400',
  warning: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400',
  error:   'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400',
  info:    'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400',
  neutral: 'bg-muted text-muted-foreground',
  orange:  'bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400',
};

export default function StatusBadge({ label, variant = 'neutral', className = '' }) {
  return (
    <span className={`inline-block px-2 py-1 text-xs rounded ${VARIANT_CLASSES[variant] || VARIANT_CLASSES.neutral} ${className}`}>
      {label}
    </span>
  );
}
